import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  IconButton,
  TextField,
  Button,
  Dialog,
  DialogActions,
  Grid,
  Autocomplete,
  Tooltip,
  Checkbox,
  Chip,
  Popover,
} from "@mui/material";
import { Add, Edit, Visibility } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import { useToastContext } from "../../../../Context/ToastContext";
import styles from "./MenuList.module.css";
import ClearIcon from "@mui/icons-material/Clear";
import Dropdown1 from "../../Dropdown/Dropdown1";
import ViewDocument from "../../ViewDocument/ViewDocument";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useUserContext } from "../../../../Context/UserContext";
import { styled } from "@mui/system";
import ribbon from "../../../../images/star.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { apiGet, apiPost, apiPut } from "../../../../utils/ApiManager";

const fetchMenuDishList = process.env.REACT_APP_FETCH_MENU_DISH_LIST;
const addMenuDish = process.env.REACT_APP_ADD_MENU_DISH;
const uploadMenuRecipe = process.env.REACT_APP_UPLOAD_MENU_RECIPE;
const updateMenuRecipe = process.env.REACT_APP_UPDATE_MENU_RECIPE;
const fetchDropdownDish = process.env.REACT_APP_FETCH_DROPDOWNS_DISH;
const togglePopular = process.env.REACT_APP_MENU_TOOGLE;
const postMenu = process.env.REACT_APP_POST_MENU_DISH;

const MenuList = () => {
  const boxRef = useRef();
  const fileInputRef = useRef(null);
  const { restaurantID } = useParams();
  const { showToast } = useToastContext();
  // const { setLoading } = useLoaderContext();
  const PAGE_SIZE = 10;
  const [pageNo, setPageNo] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [restaurantInfo, setRestarantInfo] = useState({});
  const [dishes, setDishes] = useState([]);
  const [fileIndexes, setFileIndexes] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]); // State for selected tags
  const [recipeUploading, setRecipeUploading] = useState(false); // State for
  const [newDish, setNewDish] = useState({
    restaurantId: restaurantID,
    title: "",
    description: "",
    price: "",
    dishCategory: "",
    tags: [],
    images: [],
    imageLinks: [],
    isNonVeg: false,
  });
  const [errors, setErrors] = useState({
    title: "",
    description: "",
    tags: "",
    images: "",
  });
  const [imageErrors, setImageErrors] = useState([]);
  const { requestConfirmation, getToken } = useUserContext();
  const [tagList, setTagList] = useState([]);
  const [dishCategories, setDishCategories] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [recipeFile, setRecipeFile] = useState(null);
  const [viewDocument, setViewDocument] = useState(false);
  const [documentUrl, setDocumentUrl] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const [showDocument, setShowDocument] = useState(false);
  const [recipeFileError, setRecipeFileError] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const RibbonBadge = styled("img")({
    position: "absolute",
    top: 8,
    left: 8,
    width: 40,
    height: 40,
    zIndex: 1,
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Reset the file input
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRecipeClose = () => {
    setRecipeUploading(false);
  };

  // const handleRecipeFileChange = (e) => {
  //   const file = e.target.files[0];

  //   if (file) {
  //     const isPdf = file.type === "application/pdf";
  //     const isLt300KB = file.size <= 307200;

  //     if (!isPdf) {
  //       setRecipeFileError("Only PDF files are allowed.");
  //       setRecipeFile(null);
  //     } else if (!isLt300KB) {
  //       setRecipeFileError("File size must be less than 300 KB.");
  //       setRecipeFile(null);
  //     } else {
  //       setRecipeFileError("");
  //       setRecipeFile(file); // Only set if valid
  //     }
  //   }
  // };

  const fetchDishList = async (newSearch) => {
    try {
      setLoading(true);
      let page = pageNo;
      if (newSearch) page = 1;
      if (newSearch) setHasMore(true);
      let params = {
        restaurantId: restaurantID,
        pageNo: page,
        pageSize: PAGE_SIZE,
      };
      if (searchQuery) params.searchText = searchQuery;
      const queryString = new URLSearchParams(params).toString();
      const response = await apiGet(`${fetchMenuDishList}?${queryString}`);
      if (response.success) {
        const dishData = response.data?.dishList;
        if (pageNo === 1) {
          setDishes(dishData || []);
        } else {
          setDishes((prev) => [...prev, ...dishData]);
        }
        if (dishData < PAGE_SIZE) {
          setHasMore(false);
        }
        setPageNo(page + 1);
        setRestarantInfo(response.data?.restaurantData || []);
      } else {
        showToast(response.message || "Failed to fetch dish list!", "error");
      }
    } catch (error) {
      showToast(
        error?.response?.message || "Failed to fetch dish list!",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = () => {
    const box = boxRef.current;
    if (box.scrollTop + box.clientHeight >= box.scrollHeight - 10) {
      if (hasMore && !loading) {
        fetchDishList();
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewDish((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = (e) => {
    try {
      const { value } = e.target;
      setSearchQuery(value);
    } catch (error) {}
  };

  const handleSelect = (event, newValue) => {
    setSelectedTags(newValue);
  };

  useEffect(() => {
    setPageNo(1);

    if (searchQuery) {
      const stopper = setTimeout(() => {
        setDishes([]);
        fetchDishList();
      }, 500);
      return () => clearTimeout(stopper);
    } else {
      setDishes([]);
      fetchDishList(true);
    }
  }, [searchQuery]);

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!newDish.title) {
      newErrors.title = "Title is required.";
      isValid = false;
    } else if (newDish.title.length > 35) {
      newErrors.title = "Title must be less than 35 characters.";
      isValid = false;
    }

    if (!newDish.description) {
      newErrors.description = "Description is required.";
      isValid = false;
    } else if (newDish.description.length > 50) {
      newErrors.description = "Description must be less than 50 characters.";
      isValid = false;
    }

    if (!newDish.dishCategory) {
      newErrors.dishCategory = "Dish category is required.";
      isValid = false;
    }

    if (!newDish.price) {
      newErrors.price = "Price is required.";
      isValid = false;
    }

    if (selectedTags.length === 0) {
      newErrors.tags = "At least one tag is required.";
      isValid = false;
    } else if (selectedTags.length > 5) {
      newErrors.tags = "Maximum 5 tags allowed.";
      isValid = false;
    }

    const newImageErrors = [];
    const validImages = newDish.images?.filter(Boolean) || [];

    // if (validImages.length === 0) {
    //   newErrors.images = "At least one image is required.";
    //   isValid = false;
    // }

    validImages.forEach((image, index) => {
      if (image?.size > 300 * 1024) {
        newImageErrors[index] = "File size must be less than 300KB.";
        isValid = false;
      } else {
        newImageErrors[index] = "";
      }
    });

    setErrors(newErrors);
    setImageErrors(newImageErrors);

    return isValid;
  };

  useEffect(() => {
    const valid = validateForm();
    setIsFormValid(valid);
  }, [newDish, selectedTags]);

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileSizeInKB = file.size / 1024;
    const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (fileSizeInKB > 300) {
      const newImageErrors = [...imageErrors];
      newImageErrors[index] = "File size must be less than 300 KB.";
      setImageErrors(newImageErrors);
      return;
    }

    if (!allowedFileTypes.includes(file.type)) {
      // showToast("Only image files (JPEG, PNG) are allowed.", "error");
      const newImageErrors = [...imageErrors];
      newImageErrors[index] = "Only JPEG and PNG images are allowed.";
      setImageErrors(newImageErrors);
      return;
    }

    // Clear any previous errors
    const newImageErrors = [...imageErrors];
    newImageErrors[index] = "";
    setImageErrors(newImageErrors);

    // Update images
    const updatedImages = [...newDish.images];
    updatedImages[index] = file;

    setNewDish((prev) => ({
      ...prev,
      images: updatedImages,
    }));
  };

  const handleRemoveImage = (index) => {
    setNewDish((prev) => {
      const newImages = [...prev.images];
      const newImageLinks = [...prev.imageLinks];

      newImages[index] = null;
      newImageLinks[index] = null;

      return {
        ...prev,
        images: newImages,
        imageLinks: newImageLinks,
      };
    });

    setFileIndexes((prev) => prev.filter((idx) => idx !== index));
  };

  const handleAddImageInput = () => {
    const validImages = newDish.images?.filter(Boolean) || [];

    if (validImages.length >= 4) {
      setErrors((prev) => ({
        ...prev,
        images: "You can only upload a maximum of 4 images.",
      }));
      return;
    }

    setErrors((prev) => ({
      ...prev,
      images: "",
    }));

    setNewDish((prevData) => ({
      ...prevData,
      images: [...prevData.images, null],
      imageLinks: [...prevData.imageLinks, null],
    }));
  };

  const handleAddDish = async () => {
    const result = await requestConfirmation("Want to add dish?");
    if (!result) return;

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("title", newDish.title);
      formData.append("description", newDish.description);
      formData.append("price", newDish.price);
      newDish.tags = selectedTags || [];
      newDish.images.forEach((image, index) => {
        if (image) {
          formData.append("images", image);
        }
      });

      const response = await apiPost(addMenuDish, newDish, true);
      if (response.success) {
        showToast(response.message || "Dish added successfully.", "success");
        setDishes([]);
        fetchDishList(true);
      } else {
        showToast(response.message || "Failed to add dish!", "error");
      }
    } catch (error) {
      showToast(error?.response?.message || "Failed to add dish!", "error");
    } finally {
      setLoading(false);
    }
    handleClose();
  };

  // const handleViewDocument = (file) => {
  //   if (file) {
  //     const url = URL.createObjectURL(file);
  //     setDocumentUrl(url);
  //     setShowDocument(true);
  //   } else {
  //     setDocumentUrl(newDish?.recipe);
  //     setShowDocument(true);
  //   }
  // };

  // const handleCloseDocument = () => {
  //   setDocumentUrl("");
  //   setShowDocument(false);
  // };

  const handleEditClick = (dishData) => {
    setIsEditing(true);
    setFileIndexes([]);
    handleClickOpen();

    const tags = tagList?.filter((tagData) =>
      dishData?.tags?.find((data) => data === tagData?.tagName)
    );
    setSelectedTags(tags);

    setNewDish({
      dishCode: dishData.dishCode || "",
      restaurantId: restaurantID,
      title: dishData.title || "",
      description: dishData.description || "",
      price: dishData.price || "",
      images: dishData.images || [],
      dishCategory: dishData?.dishCategory || "",
      imageLinks: dishData.images || [],
      updateIndex: [],
      isNonVeg: dishData?.isNonVeg || false,
      isPopular: dishData?.isPopular || false,
    });
  };

  // const uploadRecipe = async () => {
  //   const result = await requestConfirmation("Want to upload recipe ?");
  //   if (!result) return;

  //   try {
  //     setLoading(true);
  //     // Validate if file exists
  //     if (!recipeFile) {
  //       showToast("Please select a recipe file.", "warning");
  //       return;
  //     }

  //     // Validate file size (< 300KB)
  //     const maxSize = 300 * 1024; // 300KB in bytes
  //     if (recipeFile.size > maxSize) {
  //       showToast("File size should be less than 300KB.", "warning");
  //       return;
  //     }

  //     const formData = new FormData();
  //     formData.append("restaurantId", newDish?.restaurant?.restaurantId);
  //     formData.append("dishCode", newDish?.dishCode);
  //     formData.append("recipeFile", recipeFile);

  //     const response = await apiPut(uploadMenuRecipe, formData, true);

  //     if (response.success) {
  //       showToast(
  //         response.message || "Recipe uploaded successfully.",
  //         "success"
  //       );
  //       setRecipeFile(null);
  //       fetchDishList();
  //     } else {
  //       showToast(response.message || "Failed to upload recipe.", "error");
  //     }
  //   } catch (error) {
  //     showToast(
  //       error?.response?.message || "Failed to upload recipe.",
  //       "error"
  //     );
  //   } finally {
  //     setLoading(false);
  //   }

  //   handleRecipeClose();
  // };

  const handleUpdateDish = async () => {
    const result = await requestConfirmation("Want to edit dish?");
    if (!result) return;

    try {
      setLoading(true);
      newDish["updateIndex"] = fileIndexes || [];
      newDish["tags"] = selectedTags || [];
      const response = await apiPut(updateMenuRecipe, newDish, true);
      if (response.success) {
        showToast("Dish updated successfully...!", "success");
        setDishes([]);
        fetchDishList(true);
      } else {
        showToast(response.message || "Failed to update dish!", "error");
      }
    } catch (error) {
      showToast(error?.response?.message || "Failed to update dish!", "error");
    } finally {
      setLoading(false);
    }
    handleClose();
  };

  const fetchDropdowns = async (req, res) => {
    try {
      setLoading(true);
      const response = await apiGet(fetchDropdownDish);
      if (response.success) {
        setDishCategories(response?.data?.dishCategories || []);
        setTagList(response?.data?.tagList || []);
      } else {
        showToast("Something went wrong !", "error");
      }
    } catch (error) {
      showToast(
        error?.response?.message ||
          error?.message ||
          "Failed to fetch dropdowns!",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // const handleRecipeUploadClick = (dishData) => {
  //   setNewDish({ ...dishData });
  //   setRecipeUploading(true);
  // };

  const handleToggleAvailability = async (dishCode, newStatus) => {
    try {
      const result = requestConfirmation(
        `Want to ${newStatus ? "activate" : "deactivate"} this dish?`
      );
      if (!result) return;
      setLoading(true);

      const response = await apiPost(
        `${postMenu}/${newStatus ? "activate" : "deactivate"}/${dishCode}`,
        {}
      );

      if (response.success) {
        setDishes((prevDishes) =>
          prevDishes?.map((dish) =>
            dish.dishCode === dishCode ? { ...dish, isActive: newStatus } : dish
          )
        );
        showToast(
          response.message || "Availability updated successfully.",
          "success"
        );
      } else {
        showToast(response.message || "Something went wrong.", "error");
      }
    } catch (error) {
      showToast(
        error?.response?.message || error?.message || "Failed to update.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleToggleBestSeller = async (dishCode, isPopular) => {
    try {
      const result = await requestConfirmation(
        "Want to update best seller status?"
      );
      if (!result) return;

      if (!dishCode) return;
      setLoading(true);

      const response = await apiPut(`${togglePopular}/${dishCode}`, {
        isPopular,
      });
      if (response.success) {
        setDishes((prevDishes) =>
          prevDishes?.map((dish) =>
            dish.dishCode === dishCode ? { ...dish, isPopular } : dish
          )
        );
        setNewDish((prev) => ({ ...prev, isPopular }));
      } else {
        showToast(
          response.message || "Failed to update best seller status!",
          "error"
        );
      }
    } catch (error) {
      showToast(
        error?.response?.message ||
          error?.message ||
          "Failed to update best seller status!",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open) {
      setIsEditing(false);
      setNewDish({
        restaurantId: restaurantID,
        title: "",
        description: "",
        price: "",
        images: [],
        imageLinks: [],
      });
      setSelectedTags([]);
    }
  }, [open]);

  useEffect(() => {
    fetchDropdowns();
  }, []);

  return (
    <Box className={styles.menuPage}>
      {/* Restaurant Info Section */}
      <Box>
        <Typography variant="h4" className={styles.containerTitle}>
          Menu - {restaurantInfo.restaurantName}
        </Typography>
        <Typography variant="h6" gutterBottom align="center">
          Restaurant Code: {restaurantInfo.restaurantId}
        </Typography>
      </Box>

      {dishes?.length > 0 || searchQuery ? (
        <>
          <div className={styles.searchBarContainer}>
            <TextField
              label="Search Dish"
              variant="outlined"
              fullWidth
              onChange={handleSearch}
              className={styles.searchBar}
            />
          </div>

          <Box className={styles.dishContainer}>
            <Typography variant="h5" className={styles.containerTitle}>
              Your Menu
            </Typography>

            <Box
              ref={boxRef}
              onScroll={handleScroll}
              className={styles.dishWrapper}
            >
              {dishes?.map((dish, index) => (
                <Box key={index} className={styles.cardsContainer}>
                  <Card
                    className={styles.card}
                    sx={{
                      backgroundColor: !dish.isActive ? "grey" : "white",
                      opacity: !dish.isActive ? 0.6 : 1,
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      position: "relative",
                    }}
                  >
                    {dish.isPopular && (
                      <RibbonBadge
                        src={ribbon}
                        className={styles.popularDish}
                        alt="Popular Dish"
                      />
                    )}

                    <DishCarousel
                      className={styles.carouselImage}
                      images={dish.images}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginTop: 2,
                        marginBottom: 1,
                        width: "95%",
                      }}
                    >
                      <Tooltip
                        title={
                          dish.isActive
                            ? "Click to mark as Unavailable"
                            : "Click to mark as Available"
                        }
                        arrow
                      >
                        <Switch
                          size="small"
                          checked={dish.isActive}
                          onChange={() =>
                            handleToggleAvailability(
                              dish.dishCode,
                              !dish.isActive
                            )
                          }
                          color="success"
                          sx={{
                            "& .MuiSwitch-thumb": {
                              backgroundColor: dish.isActive ? "green" : "red",
                            },
                            "& .MuiSwitch-track": {
                              backgroundColor: dish.isActive
                                ? "rgba(76, 175, 80, 0.5)"
                                : "rgba(244, 67, 54, 0.5)",
                            },
                          }}
                        />
                      </Tooltip>

                      <Box display="flex" alignItems="center">
                        {dish.isActive ? (
                          <CheckCircleIcon fontSize="small" color="success" />
                        ) : (
                          <CancelIcon fontSize="small" color="error" />
                        )}

                        <Typography
                          sx={{ ml: 0.5, fontWeight: 500, fontSize: "0.8rem" }} // 👈 smaller font
                          variant="body2"
                          color={dish.isActive ? "success.main" : "error.main"}
                        >
                          {dish.isActive ? "Available" : "Unavailable"}
                        </Typography>
                      </Box>
                    </Box>

                    <CardContent
                      className={styles.content}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem", // adds spacing between title and price
                        }}
                      >
                        <Tooltip title={dish?.title} arrow>
                          <Typography
                            variant=""
                            sx={{
                              display: "inline-block",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              // fontFamily: '"Raleway", sans-serif',
                              // fontSize: "0.9rem",
                              fontWeight: "bold",
                              cursor: "pointer",
                              maxWidth: "100%",
                            }}
                          >
                            {dish?.title}
                          </Typography>
                        </Tooltip>
                      </Box>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontSize: "0.9rem", color: "#207d46", margin: 0 }}
                      >
                        ₹{dish.price}
                      </Typography>
                      <Tooltip title={dish.description} arrow>
                        <Typography
                          className={styles.contentDesc}
                          sx={{
                            display: "inline-block",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            fontFamily: '"Raleway", sans-serif',
                            fontSize: "0.8rem",
                            cursor: "pointer",
                          }}
                        >
                          {dish.description}
                        </Typography>
                      </Tooltip>

                      <Box className={styles.editIconContainer}>
                        <Tooltip title="Edit Dish" arrow>
                          <IconButton
                            onClick={() => handleEditClick(dish)}
                            sx={{ cursor: "pointer", color: "#207d46" }}
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                        </Tooltip>

                        {/* {dish?.recipe && (
                          <Tooltip title="View Recipe" arrow>
                            <IconButton
                              onClick={() => {
                                setViewDocument(true);
                                setDocumentUrl(dish?.recipe);
                              }}
                              sx={{ cursor: "pointer", color: 'black' }}
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )} */}

                        {/* <Tooltip title="Upload Recipe" arrow>
                          <IconButton
                            onClick={() => handleRecipeUploadClick(dish)}
                            sx={{ cursor: "pointer", color: 'black' }}
                          >
                            <BackupIcon fontSize="small" />
                          </IconButton>
                        </Tooltip> */}
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              ))}

              {/* Recipe Upload Dialog */}
              {/* <Dialog
                open={recipeUploading}
                onClose={handleRecipeClose}
                fullWidth
                maxWidth="sm"
                className={styles.recipeUploadModal}
              >
                <div
                  onClick={handleRecipeClose}
                  className={styles.backIconContainer}
                >
                  <ArrowBackIcon className={styles.backIcon} />
                </div>

                <Typography variant="h6" className={styles.titleRecipeModal}>
                  Upload Recipe
                </Typography>

                <Typography
                  variant="body2"
                  className={styles.recipeModalDishName}
                >
                  {newDish.title || "NA"}
                </Typography>

                <Box className={styles.uploadRecipeContainer}>
                  <Typography variant="caption" color="text.secondary">
                    (PDF &lt; 300kb)
                  </Typography>
                  <Box>
                    <Button
                      onClick={() =>
                        document.getElementById(`recipeUpload`).click()
                      }
                      fullWidth
                      className={styles.uploadDocumentButton}
                      startIcon={<CloudUploadIcon />}
                    >
                      {recipeFile ? "Update" : "Upload"}
                      <input
                        type="file"
                        hidden
                        accept="application/pdf"
                        id="recipeUpload"
                        onChange={handleRecipeFileChange}
                      />
                    </Button>
                    {recipeFileError && (
                      <Typography variant="body2" color="error">
                        {recipeFileError}
                      </Typography>
                    )}
                  </Box>
                  {recipeFile && (
                    <Box display="flex" justifyContent="center">
                      <Box display="flex" alignItems="center">
                        <Typography
                          variant="caption"
                          sx={{
                            display: "inline-block",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            maxWidth: 120,
                            cursor: "pointer",
                          }}
                        >
                          {recipeFile.name}
                        </Typography>
                        <IconButton onClick={() => setRecipeFile(null)}>
                          <ClearIcon sx={{ fontSize: 15 }} />
                        </IconButton>
                      </Box>
                    </Box>
                  )}

                  {(recipeFile || newDish?.recipe) && (
                    <Tooltip title="View Recipe" arrow>
                      <IconButton
                        onClick={() =>
                          handleViewDocument(recipeFile || newDish?.recipe)
                        }
                      >
                        <Visibility sx={{ fontSize: 28 }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>

                <ViewDocument
                  isOpen={showDocument}
                  onClose={handleCloseDocument}
                  documentUrl={documentUrl}
                />

                <Grid className={styles.buttonContainer}>
                  <Button
                    // sx={{backgroundColor:'#207d46'}}
                    onClick={uploadRecipe}
                    type="submit"
                    variant="contained"
                    disabled={!recipeFile || !!recipeFileError}
                  >
                    Save
                  </Button>
                </Grid>
              </Dialog> */}
              {loading && (
                <Typography
                  variant="body2"
                  className={styles.loadingText}
                  align="center"
                  sx={{ mt: 2, color: "text.secondary" }}
                >
                  Loading more dishes...
                </Typography>
              )}
            </Box>
            {/* {!hasMore && !loading && (
              <Typography
                variant="body2"
                className={styles.loadingText}
                align="center"
                sx={{ mt: 2, color: "text.secondary" }}
              >
                All dishes loaded
              </Typography>
            )} */}
          </Box>
        </>
      ) : (
        <h2 style={{ color: "red", textAlign: "center", marginTop: "2rem" }}>
          No menu registered yet !
        </h2>
      )}

      {/* The plus circle to open the modal */}
      <Box sx={{ position: "fixed", bottom: 20, right: 20 }}>
        <IconButton
          onClick={handleClickOpen}
          sx={{
            backgroundColor: "#207d46",
            color: "white",
            "&:hover": { backgroundColor: "#0b4f27" },
          }}
        >
          <Add />
        </IconButton>
      </Box>

      {/* Modal for adding or editing dishes */}
      <Dialog
        className={styles.editContainer}
        open={open}
        onClose={handleClose}
      >
        <div className={styles.backIconContainer}>
          <ArrowBackIcon
            onClick={() => handleClose()}
            className={styles.backIcon}
          />
        </div>

        <Typography variant="h5" className={styles.title}>
          {isEditing ? "Edit dish" : "Add new dish"}
        </Typography>

        <form
          className={styles.formScrollable}
          onSubmit={(e) => {
            e.preventDefault();
            if (validateForm()) {
              isEditing ? handleUpdateDish() : handleAddDish();
            }
          }}
        >
          <Grid className={styles.vegNonveg}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={newDish.isPopular}
                  onChange={(e) => {
                    const updatedValue = e.target.checked;
                    handleToggleBestSeller(newDish.dishCode, updatedValue);
                  }}
                />
              }
              label="Best Seller"
            />

            <Tooltip
              title={newDish.isNonVeg ? "Mark as Veg" : "Mark as NonVeg"}
            >
              {/* <label htmlFor="">V</label> */}
              <Switch
                checked={newDish?.isNonVeg}
                onChange={() =>
                  setNewDish({ ...newDish, isNonVeg: !newDish?.isNonVeg })
                }
                sx={{
                  "& .MuiSwitch-thumb": {
                    backgroundColor: newDish.isNonVeg ? "red" : "green",
                  },
                  "& .MuiSwitch-track": {
                    backgroundColor: newDish.isNonVeg
                      ? "lightcoral"
                      : "lightgreen",
                  },
                }}
              />
              {/* <label htmlFor="">NV</label> */}
            </Tooltip>
          </Grid>

          <Grid container spacing={2} justifyContent="center">
            <Grid className={styles.inputGroup}>
              <Dropdown1
                label={"Dish Category"}
                name={"dishCategory"}
                value={newDish.dishCategory}
                onChange={handleInputChange}
                options={dishCategories}
              />
              {errors.dishCategory && (
                <p className={styles.error}>{errors.dishCategory}</p>
              )}
            </Grid>

            <Grid className={styles.inputGroup}>
              <TextField
                label="Title"
                name="title"
                value={newDish.title}
                onChange={handleInputChange}
                className={styles.inputBox}
                fullWidth
              />
              {errors.title && <p className={styles.error}>{errors.title}</p>}
            </Grid>

            <Grid className={styles.inputGroup}>
              <TextField
                label="Description"
                name="description"
                value={newDish.description}
                onChange={handleInputChange}
                className={styles.inputBox}
                fullWidth
              />
              {errors.description && (
                <p className={styles.error}>{errors.description}</p>
              )}
            </Grid>

            <Grid className={styles.inputGroup}>
              <TextField
                label="Price"
                name="price"
                type="number"
                className={styles.inputBox}
                value={newDish.price}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  inputProps: { inputMode: "numeric", pattern: "[0-9]*" },
                  classes: { input: styles.noArrows },
                }}
              />
              {errors.price && <p className={styles.error}>{errors.price}</p>}
            </Grid>

            <Grid className={styles.inputGroup}>
              <Autocomplete
                multiple
                id="tags-outlined"
                options={tagList}
                getOptionLabel={(option) => option?.tagName}
                value={selectedTags}
                onChange={handleSelect}
                className={styles.inputBox}
                filterSelectedOptions
                renderTags={(value, getTagProps) => {
                  const visible = value.slice(0, 2);
                  const hiddenCount = value.length - visible.length;

                  return (
                    <>
                      {visible.map((option, index) => (
                        <Chip
                          key={option.tagName}
                          label={option.tagName}
                          {...getTagProps({ index })}
                          onClick={() => {}}
                          style={{ cursor: "default" }}
                        />
                      ))}
                      {hiddenCount > 0 && (
                        <Chip
                          label={`+${hiddenCount} more`}
                          onClick={(e) => {
                            setAnchorEl(e.currentTarget);
                            setPopoverOpen(true);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </>
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Tags" placeholder="Eg. Pizza" />
                )}
              />

              {errors.tags && <p className={styles.error}>{errors.tags}</p>}

              <Popover
                open={popoverOpen}
                anchorEl={anchorEl}
                onClose={() => setPopoverOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
              >
                <Box sx={{ p: 2, maxWidth: 300 }}>
                  <Typography variant="subtitle1" gutterBottom>
                    Selected Tags
                  </Typography>
                  {selectedTags.map((tag, index) => (
                    <Chip
                      key={tag.tagName}
                      label={tag.tagName}
                      onDelete={() => {
                        const updated = [...selectedTags];
                        updated.splice(index, 1);
                        handleSelect(null, updated);
                        if (updated.length <= 2) setPopoverOpen(false);
                      }}
                      sx={{ m: 0.5 }}
                    />
                  ))}
                </Box>
              </Popover>
            </Grid>

            {newDish?.images?.map(
              (image, index) =>
                index < 4 && (
                  <Box key={index} className={styles.inputBoxing}>
                    {/* Remove Icon */}
                    <Box className={styles.closeIconWrapper}>
                      <CloseIcon
                        onClick={() => handleRemoveImage(index)}
                        className={styles.closeIcon}
                        fontSize="small"
                      />
                    </Box>

                    {/* Upload Texts */}
                    <Box sx={{ textAlign: "center" }}>
                      <Typography
                        variant="body1"
                        className={styles.uploadImageTitle}
                      >
                        Upload Image
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        (Image &lt; 300kb)
                      </Typography>
                    </Box>

                    {/* Upload Button */}
                    <Button
                      variant="contained"
                      component="label"
                      className={styles.uploadDocumentButton}
                      startIcon={<CloudUploadIcon />}
                      onClick={handleClick}
                    >
                      {image ? "Update" : "Upload"}
                      <input
                        type="file"
                        hidden
                        id={`image-upload-${index}`}
                        accept="image/*"
                        onChange={(e) => handleImageChange(e, index)}
                      />
                    </Button>
                    {imageErrors?.[index] && (
                      <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                        {imageErrors[index]}
                      </Typography>
                    )}

                    {/* File Name + Remove */}
                    {image && image.name && (
                      <Box display="flex" justifyContent="center">
                        <Box display="flex" alignItems="center">
                          <Typography
                            variant="caption"
                            sx={{
                              display: "inline-block",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              maxWidth: 120,
                              cursor: "pointer",
                            }}
                          >
                            {image.name}
                          </Typography>
                          <IconButton
                            onClick={() => handleRemoveImage(index)}
                            size="small"
                            sx={{ ml: 0.5 }}
                          >
                            <ClearIcon sx={{ fontSize: 15 }} />
                          </IconButton>
                        </Box>
                      </Box>
                    )}

                    {/* Image Preview */}
                    {newDish?.imageLinks?.[index] && (
                      <CardMedia
                        component="img"
                        height="150"
                        sx={{ mt: 1, borderRadius: 1 }}
                        image={newDish.imageLinks[index]}
                        alt={`Uploaded Image ${index + 1}`}
                      />
                    )}
                  </Box>
                )
            )}

            <Grid className={styles.inputGroup}>
              {errors.images && (
                <Typography
                  color="error"
                  variant="body2"
                  sx={{ mb: 1, textAlign: "center" }}
                >
                  {errors.images}
                </Typography>
              )}
              <Button
                className={styles.addImageButton}
                onClick={handleAddImageInput}
                variant="outlined"
              >
                Add Image
              </Button>
            </Grid>
          </Grid>

          {/* <DialogActions> */}
          <Button
            className={styles.saveButton}
            onClick={() => {
              if (validateForm()) {
                isEditing ? handleUpdateDish() : handleAddDish();
              }
            }}
            variant="contained"
            sx={{
              backgroundColor: "#207d46",
            }}
            disabled={!isFormValid}
          >
            Save
          </Button>
          {/* </DialogActions> */}
        </form>
      </Dialog>

      <ViewDocument
        isOpen={viewDocument}
        onClose={() => setViewDocument(false)}
        documentUrl={documentUrl}
      />
    </Box>
  );
};

// Carousel Component
const DishCarousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  useEffect(() => {
    const stopper = setInterval(() => {
      nextImage();
    }, 3000);
    return () => clearInterval(stopper);
  }, []);

  return (
    <Box sx={{ position: "relative" }}>
      <CardMedia
        component="img"
        // alt="Dish image"
        sx={{
          height: 170,
          width: "100%",
          objectFit: "cover",
          borderTopLeftRadius: "15px",
          borderTopRightRadius: "15px",
        }}
        image={
          images[0]
            ? images[currentIndex]
            : "https://via.placeholder.com/400x300?text=No+Image"
        }
      />

      {/* Dots Navigation */}
      <Box
        sx={{
          padding: "0.2rem",
          gap: "0.5rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          position: "absolute",
          bottom: -20,
          left: 0,
          right: 0,
        }}
      >
        {/* Left Arrow */}
        {/* <KeyboardArrowLeftIcon
          onClick={prevImage}
          sx={{ cursor: "pointer", color: "black" }}
        /> */}

        {/* Dots */}
        {images?.map((_, index) => (
          <Box
            key={index}
            sx={{
              width: "5px",
              height: "5px",
              borderRadius: "50%",
              backgroundColor: currentIndex === index ? "#207d46" : "#cccccc",
              transition: "background-color 0.3s",
              margin: "0 3px",
              cursor: "pointer",
            }}
            onClick={() => setCurrentIndex(index)} // Allow user to click on a dot to navigate
          />
        ))}

        {/* Right Arrow */}
        {/* <KeyboardArrowRightIcon
          onClick={nextImage}
          sx={{ cursor: "pointer", color: "black" }}
        /> */}
      </Box>
    </Box>
  );
};

export default MenuList;
